import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { AddressLookupContainer } from '../containers/AddressLookupContainer.js';

const AddressLookup = (props)=>/*#__PURE__*/ React.createElement(AddressLookupContainer, swcHelpers.extends({}, props))
;

export { AddressLookup };
//# sourceMappingURL=AddressLookup.js.map
